import { Pedido } from '@/models/sit-pedido/pedido'

import defaultDetailState  from './states/detail'
import defaultFormState, { ContactSitPedidos, DocumentoSitPedidos } from './states/form'
import defaultTableState, { PaginationTableSitPedidos } from './states/table'

export default {
  // Mutations for Form State
  ['CLEAR_FORM'](state: any): void {
    state.form = {
      isLoading: false,
      currentStep: 1,
      pedido: null,
      documents: null,
      contact: null
    }
  },
  ['SET_FORM_DOCUMENTS'](state: any, value: DocumentoSitPedidos[]): void {
    state.form.documents = value
  },
  ['SET_FORM_DOCUMENT'](state: any, value: DocumentoSitPedidos): void {
    const document = state.form.documents.find(d=>d.tipoDocumento===value.tipoDocumento)
    const indeOf = state.form.documents.indexOf(document, 0)
    state.form.documents[indeOf] = value
  },
  ['SET_FORM_IS_LOADING'](state: any, value: boolean): void {
    state.form.isLoading = value
  },
  ['SET_FORM_PEDIDO'](state: any, value: Pedido): void {
    state.form.pedido = value
  },
  ['SET_FORM_STEP'](state: any, value: Number): void {
    state.form.currentStep = value
  },
  ['SET_FORM_PEDIDO_CONTACT'](state: any, value: ContactSitPedidos): void {
    state.form.contact = value
  },

  // Mutations for Detail State
  ['SET_DETAIL_DATA'](state: any, value: Pedido): void {
    state.detail.data = value
  },
  ['SET_DETAIL_LOADING'](state: any, value: Boolean): void {
    state.detail.isLoading = value
  },
  ['CLEAR_DETAIL'](state: any): void {
    Object.assign(state.detail, defaultDetailState)
  },

  // Mutations for Table State
  ['SET_TABLE_CONTENT'](state: any, value: Pedido[]): void {
    state.table.content = value
  },
  ['SET_TABLE_LOADING'](state: any, value: Boolean): void {
    state.table.isLoading = value
  },
  ['SET_TABLE_TOTALS'](state: any, value: Number): void {
    state.table.total = value
  },
  ['SET_TABLE_PAGINATION'](state: any, value: PaginationTableSitPedidos): void {
    state.table.paginate = value
  },
  ['CLEAR_TABLE'](state: any): void {
    // TODO: melhorar essa abordagem pra reaproveitar o initialState. Ex: defaultTableStates
    state.table.paginate = {
      input: {
        id: null,
        statuses: null,
        tipoPedido: null,
        datasCriacao: null,
        veiculoTransportadora: {
          veiculo: {
              id: null,
              placa: null
          },
          transportadora: {
            id: null,
            cnpjSemFormate: null,
            nomefantasia: null,
            razaosocial: null
         }
        }
      },
      inputPage: {
        page: 1,
        size: 10,
        sort: ['id'],
        ascendingSort: false,
      },
    }
  },
}
